export default __webpack_public_path__ + "static/6-fd5001694921407ae168efa377416ae4.jpg";